import React from 'react';

export default class FadeOutErrorMessage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            initialized: false,
            show: false
        };
    }
    mounted = false;

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.initialized && nextProps.show) {
            this.setState({ initialized: true });
        }

        if (nextProps.show !== this.state.show) {
            this.setState({ show: nextProps.show });

            if (nextProps.show) {
                if (this.props.timeOut) {
                    setTimeout(() => {
                        if (this.mounted) {
                            this.setState({ show: false });
                        }
                    }, this.props.timeOut);
                }
            }

        }
    }

    render() {
        const message = (this.props.message && this.props.message.indexOf('\n') > 0)
        ? <div>
            {this.props.message.split('\n').slice(0, 1).map((text, index) => <p key={index}>{text}</p>)}
            <div>{this.props.message.split('\n').slice(1).map((text, index) => <p key={index}>{text}</p>)}</div>
        </div>
        : (this.props.message || "Something went wrong.  Please try again.");

        return <span className={`error-label fade-error-label ${this.state.show ? "fade-in" : "fade-out"}`}>
            {this.state.initialized ? message : ""}</span>;
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/FadeOutErrorMessage.jsx